<template>
  <div class="mobile-price ui-shadow-10pt">
    <client-only>
      <PromoTimer
        v-if="promo?.landing_card_banner"
        :images="promo.landing_card_banner?.image"
        :end-promotion-date="promo.end"
        :bg-color="promo.landing_card_banner?.background_color || ''"
        :text="promo.landing_card_banner?.text"
        :text-color="promo.landing_card_banner?.text_color"
      />
    </client-only>

    <div :class="wrapperClasses">
      <UiButton
        theme="quinary"
        size="small"
        class="mobile-price__button"
        @click="$emit('click:pay', accessType === AccessTypeEnum.Free ? AccessTypeEnum.Free : AccessTypeEnum.Paid)"
      >
        {{ computedButtonText }}
      </UiButton>

      <SubscribeButtonSmart
        v-if="isSubscriptionAvailable"
        theme="secondary"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import type { Promo } from '@academica-box/swagger/marketplace'
  import PromoTimer from '@/components/PromoTimer/PromoTimer.vue'
  import SubscribeButtonSmart from '@/components/PromoButton/SubscribeButton.smart/SubscribeButton.smart.vue'

  import { AccessTypeEnum } from '@/helpers/mappingCourseData'

  const props = defineProps<{
    accessType: AccessTypeEnum;
    promo: Promo | null;
    isSubscriptionAvailable: boolean;
  }>()

  defineEmits(['click:pay'])

  const wrapperClasses = computed(() => {
    return [
      'mobile-price__wrapper',
      {
        'mobile-price__wrapper--buttons': props.isSubscriptionAvailable
      }
    ]
  })

  const computedButtonText = computed(() => {
    if (props.accessType === AccessTypeEnum.Free) {
      return 'Учиться бесплатно'
    } else if (props.isSubscriptionAvailable) {
      return 'Купить навсегда'
    }

    return 'Купить'
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/combinations/media-hover-z' as *;

  .mobile-price {
    width: 100%;
  }

  .mobile-price__wrapper {
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    width: 100%;
    padding: 8px;
    border-bottom: 1px solid var(--stroke-main-color);
    background-color: var(--bg-main-color);

    @include media(md) {
      padding: 12px;
    }

    &--buttons {
      grid-column-gap: 6px;
      grid-template-columns: 1fr 1fr;
    }
  }

  .mobile-price__notice {
    margin: 0;
    color: var(--text-secondary-color);
    text-align: center;
  }
</style>
